import { sessionState } from 'src/app/core/services/signal-state.storage';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import moment from 'moment';;
import { AppService } from 'src/app/app.service';
import { GdoCancelSubscriptionConfirmationDialogComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-cancel-subscription-confirmation-dialog/gdo-cancel-subscription-confirmation-dialog.component';
import { GdoCancelSubscriptionDialogComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-cancel-subscription-dialog/gdo-cancel-subscription-dialog.component';
import { GdoCancelSubscriptionInformationDialogComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-cancel-subscription-information-dialog/gdo-cancel-subscription-information-dialog.component';
import { GdoConnectedGarageFeaturesDialogComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-connected-garage-features-dialog/gdo-connected-garage-features-dialog.component';
import { GdoConnectedGarageIntroductionVideoDialogComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-connected-garage-introduction-video-dialog/gdo-connected-garage-introduction-video-dialog.component';
import { GdoInfoPopupDialogComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-info-popup-dialog/gdo-info-popup-dialog.component';
import { GdoSelectCancelSubscriptionDialogComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-select-cancel-subscription-dialog/gdo-select-cancel-subscription-dialog.component';
import { GdoStepCompletionStatusComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-step-completion-status/gdo-step-completion-status.component';
import { GdoTermsOfUseComponent } from 'src/app/gdo/gdo-shared/gdo-shared-components/gdo-terms-of-use/gdo-terms-of-use.component';
import {
  Ca_State_prov,
  transformIntoApiCallObj,
  Us_State_prov,
} from 'src/app/gdo/gdo-shared/Models/Constants';
import {
  AccountContract,
  IAcctDetail,
  PlanInfo,
} from 'src/app/gdo/gdo-shared/Models/Interfaces';
import {
  packageCardDetails,
  StatusDTO,
} from 'src/app/gdo/gdo-shared/Models/Models';

@Component({
  selector: 'app-gdo-subscription-detail',
  templateUrl: './gdo-subscription-detail.component.html',
  styleUrls: ['./gdo-subscription-detail.component.scss'],
  standalone: false
})
export class GdoSubscriptionDetailComponent implements OnInit {
  @Input() acctDetail!: IAcctDetail;
  @Input() selectedSP: any;
  @Input() stolenStatus: boolean = false;
  @Input() termsAndConditionStatus: any;
  prefLanguage = '';
  VIN: any;

  /*for cancel */
  currentPlanStatus: any = '';
  currentPlanStatusDate: any = '';
  currentPlanExpired: boolean = false; //set to false on below positions
  currentPlanCancelable: boolean = false; // allow cancell within 30 days
  currentPlanCancelableDateLimit: any = ''; // allow cancell within 30 days
  leftDaysForRenewable: any = '';
  currentPlanRenewable: boolean = false;
  upcomingPackageAvailable: boolean = false;
  autoRenewal: boolean = false;
  currentPlanInfo: PlanInfo = {
    planName: 'Complimentry Trial',
    months: 1,
    endDate: '27/5/26',
    contractNo: '',
    lastBillDate: '',
    nextBillDate: '',
    startDate: '',
    clientPlanInstanceId: '',
    rolloverClientPlanId: '',
    rolloverClientRateSchedId: '',
  };
  upcomingPlanInfo: PlanInfo = {
    planName: 'Complimentry',
    months: 1,
    endDate: '',
    contractNo: '',
    lastBillDate: '',
    nextBillDate: '',
    startDate: '',
    clientPlanInstanceId: '',
    rolloverClientPlanId: '',
    rolloverClientRateSchedId: '',
  };
  currentPlanRatePerUnit = 0;
  upcomingPlanRatePerUnit = 0;
  currentPlanDuration: any = '';
  upcomingPlanDuration: any = '';
  paymentMethodInfo: any;
  billingAddress = '';
  billingInfo: any = null;
  isAcura: boolean = false;
  allowCancelOrChangeSubscription = false;
  primaryPhoneNumber: any = '';
  cellPhoneNumber: any = '';
  // planDuration: string = null;
  street: any = '';
  city: any = '';
  state: any = '';
  country: any = '';
  subscriptionTypeGdo: string | null = '';
  startDateForUI: any;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private appService: AppService
  ) { }

  ngOnInit(): void {

    this.languageDisplayValue();
    this.setBillingInfo();
    this.VIN = this.appService.getVIN();

    this.getPlansInfo();
    this.getTermsAndConditionsStatus();
    if (this.acctDetail) {
      this.primaryPhoneNumber = this.changePhoneNumberFormat(
        this.acctDetail.phone
      );
      this.cellPhoneNumber = this.changePhoneNumberFormat(
        this.acctDetail.cellPhone
      );
      this.getConstructedAddress(this.acctDetail);
    }
    this.currentPlanStatus = this.selectedSP?.suppPlanInstanceStatus;
    this.currentPlanRenewable = this.getRenewableStatus(
      this.currentPlanInfo.endDate
    );
    this.subscriptionTypeGdo = sessionState.getItem('subscriptionTypeGdo');
    let vehicleData = sessionState.getItem("vehicleMake");
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
    this.appService.checkPlannedBillingDate(this.currentPlanInfo, this.VIN, 'GDO_myQ');
  }

  checkNullAddress(data: string | undefined) {
    if (data && data.length > 0) {
      return data + ',';
    } else return '';
  }
  getConstructedAddress(data: any) {
    //
    this.street = data.address1 ? data.address1 : '';
    this.street = data.address2
      ? this.checkNullAddress(this.street) +
      this.checkNullAddress(data.address2)
      : this.checkNullAddress(this.street);

    // this.city = data.city
    //   ? this.city + ' ' + data.city
    //   : this.city;
    this.city = data.city ? data.city : '';

    if (data.completeConstrunctedAddress.indexOf('United States') !== -1) {
      this.country = 'United States';
      if (data.stateProv) {
        const result = Us_State_prov.filter((item) => {
          return item.value === data.stateProv;
        });
        if (result && result.length > 0) {
          this.state = result[0].displayValue;
        }
      }
    } else if (data.completeConstrunctedAddress.indexOf('Canada') !== -1) {
      this.country = 'Canada';
      if (data.stateProv) {
        const result = Ca_State_prov.filter((item) => {
          return item.value === data.stateProv;
        });
        if (result && result.length > 0) {
          this.state = result[0].displayValue;
        }
      }
    } else if (
      data.completeConstrunctedAddress.indexOf('United Kingdom') !== -1
    ) {
      this.country = 'United Kingdom';
    } else {
      this.country = '';
    }

    this.city = this.state
      ? this.checkNullAddress(this.city) + this.checkNullAddress(this.state)
      : this.checkNullAddress(this.city);
  }

  changePhoneNumberFormat(phone: string | undefined) {
    if (phone) {
      phone = phone.replace(/[^\d]/g, '');
      if (phone.length >= 10) {
        return phone.replace(/(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
      }
    }

    return null;
  }
  onViewBillingHistoryClick() {
    this.router.navigate(['billing/billingHistory'], {
      queryParams: { activeTab: 1 },
    });
  }

  onEditSubscriptionInfo() {

    this.router.navigate(['gdo-product/subscriber-contact-info']);
  }

  onUpdatePaymentMethodClicked() {
    //
    this.router.navigate(['/billing']);
  }

  onViewmyQConnectedGarageDemoClick() {
    let dialogRef = this.dialog.open(
      GdoConnectedGarageIntroductionVideoDialogComponent,
      {
        width: '96vh',
        data: {},
      }
    );
  }

  onViewmyQConnectedGarageFeatureClick() {
    let dialogRef = this.dialog.open(
      GdoConnectedGarageFeaturesDialogComponent,
      {
        // height: '78vh',
        // width: '40vw',
        data: {},
      }
    );
  }

  onViewTermsOfServiceClick() {
    let dialogRef = this.dialog.open(GdoTermsOfUseComponent, {
      height: '85vh',
      width: '85vw',
      data: { showAcceptBtn: false },
    });
  }

  /**
   * Cancel process initiated
   */
  async onCancelSubscriptionClicked() {
    // first we have to evaluate past 48hours to see if the chancel-Subscription is appilcable
    this.allowCancelOrChangeSubscription =
      this.appService.canCancelOrChangeSubscription(
        this.selectedSP,
        this.currentPlanDuration
      );

    if (!this.allowCancelOrChangeSubscription) {
      this.dialog.open(GdoInfoPopupDialogComponent, {
        panelClass: 'custom-modalbox',
        width: '550px',
        maxWidth: '90vw',
        disableClose: true,
        data: {
          title: 'Cancel Subscription',
          infoMsg:
            'A cancellation can only be made 48 hours after the purchase of the subscription.',
          btnText: 'Close'
        }
      });
      return;
    }
    else {
      //
      // get current and upcoming package details
      let currentPackage: packageCardDetails = {
        duration: this.currentPlanDuration,
        packageDescription:
          'Paid and dealer Telematics supplemental plan for the US.',
        packagePrice: this.currentPlanRatePerUnit,
        packageTitle: this.currentPlanInfo?.originalPlanName ?? '',
        subsStartDate: null,
        subsExpiryDate: this.currentPlanInfo?.endDate ?? '',
        isCurrent: true,
        upcomingPlanDuration: this.upcomingPlanDuration,
      };

      let upcomingPackage: packageCardDetails = {
        duration: this.upcomingPlanDuration,
        packageDescription:
          'Paid and dealer Telematics supplemental plan for the US.',
        packagePrice: this.upcomingPlanRatePerUnit,
        packageTitle: this.upcomingPlanInfo?.originalPlanName ?? '',
        subsStartDate: this.upcomingPlanInfo?.startDate ?? null,
        subsExpiryDate: '',
        isCurrent: false,
        upcomingPlanDuration: '',
      };

      // now get the popup to select the subscription
      let dialog = this.dialog.open(
        GdoSelectCancelSubscriptionDialogComponent,
        {
          data: {
            currentPackage: currentPackage,
            upcomingPackage: upcomingPackage,
          },
        }
      );

      //after attaining the subsription item now we initiate the cancellation process
      const selectionDialogReturn =
        dialog.componentInstance.onSelectCancelSubscription.subscribe(
          (response) => {

            //
            // we will open the other information pop up
            // only if user selects to remove trial cancelation as well
            if (
              response &&
              response.cancelSubscription &&
              response.fullCancelation
            ) {
              this.onCancelSubscription(response.fullCancelation);
            } else if (response && response.cancelSubscription) {
              this.onCancelSubscriptionConfirmationClicked(
                response.fullCancelation
              );
            }
          }
        );
    }
  }

  /**
   * Step 2 of Cancel process
   */
  // this will open  pop up only if user selects to remove trial cancelation as well
  async onCancelSubscription(fullCancelation: boolean) {
    const amountToRefund = await this.getRefund(fullCancelation);

    // if amount is > 0 then we will consider if refunable otherwise not
    let isRefundable = amountToRefund > 0 ? true : false;

    let dialogRef = this.dialog.open(
      GdoCancelSubscriptionInformationDialogComponent,
      {
        width: '60vw',
        height: '70vh',
        data: {
          currentPlanName: this.currentPlanDuration,
          isRefundable,
          amountToRefund,
        },
      }
    );

    // if action of cancel subscription performed
    const sub = dialogRef.componentInstance.onCanceledSubscription.subscribe(
      (res) => {
        if (res && res.proceedCancelation) {
          this.onCancelSubscriptionConfirmationClicked(fullCancelation);
        }
      }
    );
  }

  /**
   * Step 3 of Cancel process
   */
  // Cancell the subscription
  async onCancelSubscriptionConfirmationClicked(fullCancelation: boolean) {
    let today = this.getToday();
    const amountToRefund = await this.getRefund(fullCancelation);

    // if amount is > 0 then we will consider if refunable otherwise not
    let isRefundable = amountToRefund > 0 ? true : false;

    let dialogRef = this.dialog.open(GdoCancelSubscriptionDialogComponent, {
      width: '60vw',
      data: {
        currentPlanName: this.currentPlanDuration,
        isRefundable,
        amountToRefund,
        suffix: this.paymentMethodInfo?.suffix,
      },
    });

    const sub = dialogRef.componentInstance.onCancelledSubscription.subscribe(
      (reason) => {
        let data = {
          eventType: 'cancelWithoutRefund',
          cancelType: fullCancelation ? '' : 'Partial',
          doWrite: true,
          clientPlanInstanceIdMPI:
            this.appService.getSelectedMp()?.clientMasterPlanInstanceId,
          clientPlanInstanceIdSPI: this.selectedSP?.clientSuppPlanInstanceId,
          effectiveDate: today,
          altProrationStartDate: today,
          reasonForCancel: reason,
        };

        // Cancel Api Call
        this.appService.CancelSubscription(data).subscribe(
          (res) => {
            if (res.status == 'success') {
              let ref = this.dialog.open(
                GdoCancelSubscriptionConfirmationDialogComponent,
                {
                  data: {
                    currentPlanName: this.currentPlanDuration,
                    isRefundable,
                    amountToRefund,
                    suffix: this.paymentMethodInfo?.suffix,
                    isAcura: this.isAcura,
                  },
                }
              );

              ref.afterClosed().subscribe(() => {
                this.router.navigateByUrl('/gdo-product');
                this.appService.resetTndC('GDO_myQ', this.VIN);
              });
            } else {
              let statusData: StatusDTO = {
                title: 'Failed',
                details: 'Subscription Cancellation Failed',
                descriptionHtml: `<p>Something went wrong. Please try again</p>`,
                stepSuccessful: false,
              };

              this.dialog.open(GdoStepCompletionStatusComponent, {
                data: statusData,
              });
            }
          },
          (err) => {
            let statusData: StatusDTO = {
              title: 'Failed',
              details: err.error.errorResponse,
              stepSuccessful: false,
            };
            let ref = this.dialog.open(GdoStepCompletionStatusComponent, {
              data: statusData,
            });
            ref.afterClosed().subscribe((result) => {
              this.router.navigateByUrl('/gdo-product');
            });
          }
        );
      }
    );
    dialogRef.afterClosed().subscribe(() => {
      sub.unsubscribe();
      sessionState.removeItem('upcomingPackage');
    });
  }

  onChangeSubscriptionClick() {
    this.appService.setSubsSelectedPackage(null);
    this.appService.setSubsContactInfo(null);
    this.appService.setNewPaymentMethodInfo(null);
    let currentSubscribedPackg: packageCardDetails = {
      // duration: this.upcomingPackageAvailable ? this.upcomingPlanDuration : this.currentPlanDuration,
      duration: this.currentPlanDuration,
      packageDescription:
        'Paid and dealer Telematics supplemental plan for the US.',
      // packagePrice: this.upcomingPackageAvailable ? this.upcomingPlanRatePerUnit : this.currentPlanRatePerUnit,
      packagePrice: this.currentPlanRatePerUnit,
      // packageTitle: this.upcomingPackageAvailable ? this.upcomingPlanInfo?.planName : this.currentPlanInfo?.planName,
      packageTitle: this.currentPlanInfo?.planName ?? '',
      subsStartDate: null,
      // subsExpiryDate: this.upcomingPackageAvailable ? this.upcomingPlanInfo?.endDate : this.currentPlanInfo?.endDate,
      subsExpiryDate: this.currentPlanInfo?.endDate ?? '',
      isCurrent: true,
      upcomingPlanDuration: this.upcomingPlanDuration,
    };

    this.appService.setCurrentPackgDetails(currentSubscribedPackg);
    this.appService.setSelectedSp(this.selectedSP);

    // let subsTitle = 'Change Subscription';
    let subsTitle = 'Purchase Subscription'; //HLAL-3210 request

    if (this.currentPlanDuration == 'Trial' && !this.upcomingPackageAvailable) {
      subsTitle = 'Purchase Subscription';
    }
    sessionState.setItem('titleSubscription', subsTitle);
    sessionState.setItem('showResetPin', 'false');
    if (
      subsTitle == 'Purchase Subscription' &&
      this.termsAndConditionStatus !== 'Accepted'
    ) {
      let dialogRef = this.dialog.open(GdoTermsOfUseComponent, {
        height: '85vh',
        width: '85vh',
        data: { showAcceptBtn: true },
      });

      const sub = dialogRef.componentInstance.onTermsAccepted.subscribe(
        async () => {
          let data = {
            tcAction: {
              name: 'GDO_myQ',
              acceptStatus: 'Accepted',
              version: '1.0',
              device: this.VIN,
              entityId: '',
            },
          };
          this.appService.TcAction(data).subscribe(
            (res) => {

              if (
                res &&
                res.tcAction &&
                res.tcAction.status &&
                res.tcAction.status == 'SUCCESS'
              ) {
                this.router.navigate(['gdo-product/manage-billing'], {
                  queryParams: { title: 'Purchase Subscription' },
                });
              }
            },
            (err) => {
              this.router.navigate(['gdo-product/manage-billing'], {
                queryParams: { title: 'Purchase Subscription' },
              });
            }
          );
        }
      );
      dialogRef.afterClosed().subscribe(() => {
        sub.unsubscribe();
      });
    } else {
      this.router.navigate(['gdo-product/manage-billing'], {
        queryParams: { title: subsTitle },
      });
    }
  }
  /**
   * HELPER FUNCTIONS FROM SSP BELOW!
   * */

  setBillingInfo() {
    //
    this.paymentMethodInfo = this.acctDetail?.paymentMethodsInfo;
    if (this.paymentMethodInfo && this.paymentMethodInfo.length > 0) {
      this.paymentMethodInfo = this.paymentMethodInfo[0];
    }
    this.billingInfo = this.acctDetail?.billingGroupsInfo;
    if (this.billingInfo && this.billingInfo.length > 0) {
      this.billingInfo = this.billingInfo[0];
    }
    this.billingAddress = this.billingInfo.stmtAddress1
      ? this.billingInfo.stmtAddress1
      : this.billingInfo?.stmtAddress2;
  }
  getPlansInfo() {
    //  ;
    let acctContract = this.selectedSP?.acctContracts;
    let clientSuppPlanInstanceId = this.selectedSP?.clientSuppPlanInstanceId;

    let rateScheduleId = this.selectedSP?.clientAltRateScheduleId;
    if (acctContract && acctContract.length > 0) {
      let selectedAccContract = acctContract[0];
      this.getClientPlan(rateScheduleId, true);
      this.setCurrentPlan(selectedAccContract, rateScheduleId);

      var packageEndDate = new Date(selectedAccContract?.endDate ?? '');
      if (
        packageEndDate.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
      ) {
        this.currentPlanExpired = false;
        this.setUpcomingPlan(acctContract);
      }
    }
    // // when we dont have a contract active
    else
      if ((acctContract && acctContract.length == 0) || (this.selectedSP?.suppPlanInstanceStatus == "Cancelled")) {
        this.currentPlanExpired = true;
        this.currentPlanStatus = this.selectedSP?.suppPlanInstanceStatus
        this.currentPlanStatusDate = this.selectedSP?.statusDate
        this.currentPlanRenewable = this.getRenewableStatus(this.currentPlanInfo.endDate);
        this.currentPlanDuration = this.getPlanDuration(rateScheduleId);
        this.currentPlanInfo.planName = (this.currentPlanDuration == 'Trial') ? "Complimentary " + this.currentPlanDuration : this.currentPlanDuration + " Subscription"//(this.isAcura == true) ? "myQ Connected Garage For AcuraLink" : "myQ Connected Garage For HondaLink"
        this.currentPlanInfo.endDate = this.convertToPDT(this.selectedSP?.statusDate)
      }

      else {
        // if (this.isAutoRenewal()) {
        this.autoRenewal = true;
        // }
        this.currentPlanExpired = false;
        this.getClientPlan(rateScheduleId, true);
        // this.setCurrentAutoRenwelPlan(rateScheduleId)
      }
  }

  isAutoRenewal() {
    let isAutoRenewed = false;
    for (const sp_field_iterator of this.selectedSP?.spPlanInstFields) {
      if (
        sp_field_iterator.planInstanceFieldName === 'Automatic' &&
        sp_field_iterator.planInstanceFieldValue === 'Renewal'
      ) {
        isAutoRenewed = true;
      }
    }
    return isAutoRenewed;
  }

  // for refunding //no refund in GDO
  async getRefund(fullCancelation: boolean) {
    let amountToRefund = 0;
    let today = this.getToday();
    let data = {
      // No Need to send the EventType in the payload as Backend will determine the refund logic
      // eventType: "cancelWithRefund",
      cancelType: fullCancelation ? '' : 'Partial',
      doWrite: false,
      clientPlanInstanceIdMPI:
        this.appService.getSelectedMp()?.clientMasterPlanInstanceId,
      clientPlanInstanceIdSPI: this.selectedSP?.clientSuppPlanInstanceId,
      effectiveDate: today,
      altProrationStartDate: today,
      reasonForCancel: 'Not Using It',
    };

    let tempCancelRes = await this.appService
      .CancelSubscription(data)
      .toPromise();
    if (tempCancelRes.status == 'success') {
      let responseBody = tempCancelRes.responseBody;
      if (
        responseBody &&
        responseBody.cancelAcctPlan &&
        responseBody.cancelAcctPlan.prorationCreditResultAmount
      ) {
        amountToRefund = Math.abs(
          responseBody.cancelAcctPlan.prorationCreditResultAmount
        );
      }
    }
    return 0; //amountToRefund;
  }

 
  formatDate(date: string | number | Date | undefined) {
    const parsedDate = new Date(date ?? '');
    return (
      parsedDate.getMonth() +
      1 +
      '/' +
      parsedDate.getDate() +
      '/' +
      parsedDate.getFullYear()
    );
  }

  formatDate2(date: string | number | Date | undefined) {
    if (date) {
      let dt = new Date(date);
      return (
        dt.getFullYear() +
        '-' +
        (dt.getMonth() < 10 ? '0' + (dt.getMonth() + 1) : dt.getMonth() + 1) +
        '-' +
        (dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate())
      );
    } else {
      return null;
    }
  }
  convertToPDT(date: string | number | Date | undefined) {

    /**
     * considering PST = UTC-8 as UTC= PST+8
     */
    var d = new Date(date + "T00:00:00.000-08:00"); //with GMT-8:PST added : Mon Jul 03 2023 00:00:00 GMT+0500 (Pakistan Standard Time)
    // )
    // )

    // d = new Date(date) //with GMT+5 added: Mon Jul 03 2023 05:00:00 GMT+0500 (Pakistan Standard Time)
    // 
    return (new Date(d).getMonth() + 1 + '/' + new Date(d).getDate() + '/' + new Date(d).getFullYear());
  }

  getTermsAndConditionsStatus() {
    this.appService.TcStatus(null).subscribe((res) => {
      if (res) {
        const document = new DOMParser().parseFromString(res, 'application/xml');
        var elements = document.getElementsByTagName('acceptStatus');
        if (elements && elements.length > 0) {
          this.termsAndConditionStatus = elements[0].textContent;
        }
      }
    });
  }

  languageDisplayValue() {
    if (
      this.acctDetail &&
      this.acctDetail?.acctLocaleName == 'System_US_English_locale'
    ) {
      this.prefLanguage = 'English';
    } else if (this.acctDetail && this.acctDetail?.acctLocaleName == 'fr_CAN') {
      this.prefLanguage = 'French';
    }
  }

  getMonthDifference(date: string | number | Date | undefined) {
    const currentDate = new Date();
    var expiryDate = new Date(date ?? '');
    return (
      expiryDate.getMonth() -
      currentDate.getMonth() +
      12 * (expiryDate.getFullYear() - currentDate.getFullYear())
    );
  }

  getClientPlan(rateScheduleId: string | null | undefined, currentPlan: boolean) {
    //
    let data = {
      include_all_rate_schedules: true,
    };
    data = transformIntoApiCallObj(data, 'get_client_plans_all_m');

    this.appService.AriaPassThroughConnect(data).subscribe((res) => {
      if (res && res.error_code === 0) {
        //  ;
        let plan: any;
        let planInfo = res.all_client_plan_dtls;
        for (const iterator of planInfo) {
          let allPlanServiceRates =
            iterator.plan_services?.[0]?.all_plan_service_rates;
          if (allPlanServiceRates) {
            for (const rate_iterator of allPlanServiceRates) {
              if (rate_iterator.client_rate_schedule_id === rateScheduleId) {
                plan = rate_iterator;
                break;
              }
            }
          }
          if (plan) break;
        }
        if (plan) {
          if (currentPlan) {
            this.currentPlanRatePerUnit =
              plan?.plan_service_rates?.[0]?.rate_per_unit;
          } else {
            this.upcomingPlanRatePerUnit =
              plan?.plan_service_rates?.[0]?.rate_per_unit;
          }
        }
      }
    });
  }

  titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  getPlanDuration(clientAltRateScheduleId: string | null | undefined) {
    if (!clientAltRateScheduleId) return null;
    //
    let arrayRateSchedule = clientAltRateScheduleId.split('_');
    if (arrayRateSchedule) {
      let arrLen = arrayRateSchedule?.length;
      if (arrLen) {
        if (arrLen > 2 && arrayRateSchedule[arrLen - 1] == 'Trial') {
          return this.titleCaseWord(
            arrayRateSchedule[arrLen - 1].toLowerCase()
          );
        } else {
          let duration = this.titleCaseWord(
            arrayRateSchedule[arrLen - 1].toLowerCase()
          );
          if (duration == '3year') {
            return '3 Year';
          } else if (duration == '5year') {
            return '5 Year';
          } else return null;
        }
      }
    }
    return null;
  }
  isRefunable() {
    let isRefundable = false;
    if (
      (this.currentPlanDuration == '5 Year' ||
        this.currentPlanDuration == '3 Year') &&
      this.getMonthDifference(this.currentPlanInfo.nextBillDate) > 1
    ) {
      isRefundable = true;
    }
    return isRefundable;
  }

  async setCurrentAutoRenwelPlan(rateScheduleId: string | null | undefined) {
    if (this.selectedSP) {
      this.currentPlanDuration = this.getPlanDuration(rateScheduleId);
      // getting the plan name when account contract is empty
      let data = {
        client_plan_id: this.selectedSP.clientSuppPlanId,
      };
      data = transformIntoApiCallObj(data, 'get_client_plans_basic_m');
      let selectedPlanName = '';
      let response: any = await this.appService
        .AriaPassThroughConnect(data)
        .toPromise();
      if (
        response &&
        response.error_code === 0 &&
        response.error_msg === 'OK'
      ) {
        let planDetails = response.plan_details;
        for (const iterator of planDetails) {
          if (iterator.plan_no === this.selectedSP.suppPlanNo) {
            selectedPlanName = iterator.plan_name;
            break;
          }
        }
      }


      this.currentPlanInfo.planName = this.currentPlanDuration + " Subscription";
      this.currentPlanInfo.months = this.getMonths(this.selectedSP?.planDate, this.selectedSP?.nextBillDate);
      this.currentPlanInfo.lastBillDate = String(this.appService.formatApiDate(this.selectedSP?.lastBillDate ?? ''));
      this.currentPlanInfo.nextBillDate = String(this.appService.formatApiDate(this.selectedSP?.nextBillDate ?? ''));
      this.currentPlanInfo.startDate = String(this.appService.formatApiDate(this.selectedSP?.planDate ?? ''));
      var endDate = new Date(this.selectedSP?.nextBillDate ?? '')
      endDate.setDate(endDate.getDate() - 1)
      this.currentPlanInfo.endDate = this.convertToPDT(endDate) //this.formatDate2(endDate)
      this.currentPlanInfo.contractNo = "";
      if (this.currentPlanDuration == "Trial") {
        let trialDuration = this.calculateTrialDuration()
        this.currentPlanInfo.planName = trialDuration + " Trial"
      }
    }
  }

  // TODO: fix logic for upcomig package, reference: Product Card component for updated function implementation
  setUpcomingPlan(acctContract: AccountContract[]) {
    //
    if (
      acctContract &&
      acctContract.length >= 2 &&
      acctContract[0].contractPlanInstanceInfo &&
      acctContract[0].contractPlanInstanceInfo.length > 0 &&
      acctContract[0].contractPlanInstanceInfo[0].rolloverClientRateSchedId &&
      (acctContract[0].contractPlanInstanceInfo[0].rolloverClientRateSchedId.includes(
        '5YEAR'
      ) ||
        acctContract[0].contractPlanInstanceInfo[0].rolloverClientRateSchedId.includes(
          '3YEAR'
        ))
    ) {
      this.upcomingPlanInfo.clientPlanInstanceId =
        acctContract[1]?.contractPlanInstanceInfo?.[0]?.clientPlanInstanceId;
      let rolloverClientRateSchedId =
        acctContract[0]?.contractPlanInstanceInfo[0].rolloverClientRateSchedId;
      this.getClientPlan(rolloverClientRateSchedId, false);
      this.upcomingPackageAvailable = true;
      // this.autoRenewal = false
      this.upcomingPlanDuration = this.getPlanDuration(
        rolloverClientRateSchedId
      );

      //
      this.upcomingPlanInfo.planName =
        this.upcomingPlanDuration + ' Subscription';
      this.upcomingPlanInfo.months = this.getMonths(
        acctContract[1]?.startDate,
        acctContract[1]?.endDate
      );
      this.upcomingPlanInfo.lastBillDate = this.formatDate(
        this.selectedSP?.lastBillDate
      );
      this.upcomingPlanInfo.nextBillDate = this.formatDate(
        this.selectedSP?.nextBillDate
      );

      this.startDateForUI = String(this.appService.formatApiDate(acctContract[1]?.startDate ?? ''));

      this.upcomingPlanInfo.rolloverClientPlanId =
        acctContract[0]?.contractPlanInstanceInfo[0]?.rolloverClientPlanId;
      this.upcomingPlanInfo.rolloverClientRateSchedId =
        acctContract[0]?.contractPlanInstanceInfo[0]?.rolloverClientRateSchedId;
      this.upcomingPlanInfo.endDate = this.formatDate2(
        acctContract[1]?.endDate
      ) ?? undefined;
      this.upcomingPlanInfo.contractNo = acctContract[1]?.contractNo;


    }
    else {
      this.upcomingPackageAvailable = false;
    }
  }

  setCurrentPlan(selectedContract: AccountContract, rateScheduleId: string | null | undefined) {
    //
    if (selectedContract) {
      this.currentPlanDuration = this.getPlanDuration(rateScheduleId);

      this.currentPlanInfo.planName =
        this.currentPlanDuration + ' Subscription';
      this.currentPlanInfo.months = this.getMonths(
        selectedContract?.startDate,
        selectedContract?.endDate
      );
      this.currentPlanCancelable = this.get30daysDurationStatus(
        selectedContract?.startDate
      ); // set true if days < 30
      this.currentPlanCancelableDateLimit = this.getDayForCancelPolicy(
        selectedContract?.startDate
      ); // cancelable days end on this day
      this.currentPlanStatus = this.getPlanStatus(selectedContract?.endDate);

      // }
      this.currentPlanInfo.lastBillDate = String(this.appService.formatApiDate(this.selectedSP?.lastBillDate ?? ''));
      this.currentPlanInfo.nextBillDate = String(this.appService.formatApiDate(this.selectedSP?.nextBillDate ?? ''));
      this.currentPlanInfo.startDate = String(this.appService.formatApiDate(selectedContract?.startDate ?? ''));
      this.currentPlanInfo.endDate = this.convertToPDT(selectedContract?.endDate); //this.formatDate2(selectedContract?.endDate)
      this.currentPlanInfo.contractNo = selectedContract?.contractNo;
      if (this.currentPlanDuration == 'Trial') {
        let trialDuration = this.calculateTrialDuration();
        this.currentPlanInfo.planName = trialDuration + ' Trial';
      }
    }
  }

  getMonths(std: string | number | Date | undefined, end: string | number | Date | undefined) {
    let d2 = new Date(end ?? '');
    let d1 = new Date(std ?? '');
    let months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    // −−−−−−−−−−−−−−−−−−−−^^^^
    months += d2.getMonth() + 1;
    return months;
  }

  calculateTrialDuration() {
    // let trialDuration = this.getTrialPlanDuration(this.currentPlanInfo.startDate, this.currentPlanInfo.endDate)
    // if (trialDuration > 0) {
    //   return trialDuration + " Month Complimentary"
    // }
    return ' Complimentary';
  }

  getTrialPlanDuration(startDate: string | undefined, endDate: string | undefined) {
    return Math.ceil(moment(endDate).diff(moment(startDate), 'months', true));
  }

  get30daysDurationStatus(startDate: string | undefined) {
    let currentDate = new Date();
    let diff = Math.ceil(
      moment(currentDate).diff(moment(startDate), 'days', true)
    );
    return diff <= 30;
  }
  getDayForCancelPolicy(startDate: string | undefined) {
    return moment(startDate).add(1, 'month').calendar();
  }

  getPlanStatus(endDate: string | undefined) {
    let currentDate = new Date();
    let status = Math.ceil(
      moment(endDate).diff(moment(currentDate), 'days', true)
    );

    return status <= 0 ? 'Expired' : this.selectedSP?.suppPlanInstanceStatus;
  }

  getRenewableStatus(endDate: string | undefined) {
    let current = new Date();
    let diff = Math.ceil(moment(endDate).diff(moment(current), 'days', true));
    this.leftDaysForRenewable = diff.toString();
    return diff <= 90;
  }

  getToday() {
    const d = new Date();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
  }

  redirectTo(uri: string) {
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([uri]));
  }

}
